import styled from "styled-components";

export const Hme = styled.main`

.intro{
    position: relative;
    
}
.intro section{
    position: absolute;
    width: 650px;
    transform: translate(-50%,-50%);
    top: 50%;
    left: 50%;
}
.text2{
    background-color: #ffffff99;
    border-radius: 5px;
    padding: 10px;
}
.text2 h1{
    font-family: lilyscript;
    background-color: #ffffff;
    background: #121FCF;
    background: linear-gradient(to right, #121FCF 0%, #CF1512 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    
}
.text1{
    color: #fff;
   
}
.intro img{
    
    filter: brightness(45%);
}
.actions{
    margin: 50px 0px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.actions a{
   display: flex;
   font-weight: 500;
   width: 300px;
   justify-content: center;
   
}
.actions a i{
    margin: 0px 10px;
    align-self: center;
}
.showcase, .showcase2, .showcase3{
    margin: 25px 25px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
}
.sitting, .cuisine, .weekends{
    width: fit-content;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}
.cuisine{
    flex-wrap: wrap-reverse;
}
.carousel{
    width: 500px;
}
.carousel, .text{
    margin: 20px;
}
.sitting .text{
    font-family: itim;
    background: #121FCF;
    background: linear-gradient(to right, #121FCF 0%, #CF1512 100%);
}
.cuisine .text{
    font-family: Poppins;
    background: #c21500;
    background: linear-gradient(to right, #c21500 0%, #ffc500 100%);
}
.weekends .text{
    font-family: lilyscript;
    background: #00c6ff;
    background: linear-gradient(to right,#00c6ff 0%, #0072ff 50%, #A5FECB 100%);
}
.cuisine .text a{
    display: flex;
    justify-content: center;
    font-weight: 500;
    -webkit-text-fill-color:  #fff;
}
.cuisine .text a i{
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    margin: 0px 10px;
    align-self: center;
}
.sitting .text, .cuisine .text, .weekends .text{
    align-self: center;
   
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}
.sitting img, .cuisine img, .weekends img{
  border-radius: 5px;
}
.sitting .carousel h1{
    font-family: itim;
    background-color: #00000050;
    color: #fff;
}
.weekends .carousel h1{
    font-family: lilyscript;
    background-color: #00000050;
    color: #fff;
}
.cuisine .carousel h1{
    font-family: Poppins;
    background-color: #00000050;
    color: #fff;
    font-weight: 500;
}
.hours-wrap{
    display: flex;
    justify-content: center;
}
.hours{
    border-radius: 5px;
    padding: 15px;
    background-color: #ffffff30
}
.hours div div{
    color: #007;
    font-weight: 500;
}
.hr-h{
    padding: 7px;
    display: flex;
    justify-content: center;
}
.hr-h h2{
    padding: 5px;
    background-color: #ffffff30;
    color: #007;
    width: 338px;
    text-align: center;
    border-radius: 5px;
}
.hours div{
    display: flex;
}
.conc{
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
}
.day{
    width: 200px;
}
.about{
    margin: 0px 15px;
}
.about h2{
    color: #ffc500;
}
@media (max-width: 680px){
    .intro img{
        height: 350px;
    }
    
    .carousel{
        height: auto;
        width: 45vh;
        
    }
    .carousel img{
        height: 250px;
    }
    .actions a{
        display: flex;
        font-weight: 500;
        width: 150px;
        justify-content: center;
   
    }
    .intro section{
        position: absolute;
        width: 350px;
        transform: translate(-50%,-50%);
        top: 55%;
        left: 50%;
    }
    .text br{
        display: none;
    }
}
`